var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.config.ui_version==3.5)?_c('header3Dian5'):_c('headerHOme')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }